import React from "react";
import Animation from "../../asset/video-fx/animation-c3.webm";
// import AnimationData from "../../asset/json-fx/data.json";
// import lottie from "lottie-web";
import DetectDevice from "../../utils/detectDevice";
import './style.css';

const Section2 = () => {
  const {mobile} = DetectDevice();
  const [fS, setFS] = React.useState(3);
  const [paddingVal, setPaddingVal] = React.useState(200);
  const [scaleVal, setScaleVal] = React.useState(1);
  const [animationHeight, setAnimationHeight] = React.useState(0);
  const headingRef = React.useRef(null);

  React.useEffect(() => {
    mobile ? setFS(3) : setFS(5);
    mobile ? setPaddingVal(100) : setPaddingVal(200);
    mobile ? setScaleVal(1.6) : setScaleVal(1);
  }, [mobile]);

  React.useEffect(() => {
    if (headingRef.current) {
      setAnimationHeight(headingRef.current.offsetHeight);
    }
  }, []);
  
  return (
    <>
      <div className="section-2 d-flex flex-column align-items-center justify-content-center">
        <div className="col-12 col-lg-8 text-center z-3 heading-container"
          ref={headingRef}
          style={{
            paddingTop: paddingVal,
            paddingBottom: paddingVal,
            fontSize: `${fS}rem`,          
            }}>          
          <div className="fw-bold card-title">
            How secure is your business today?
          </div>
        </div>
        <div className={`w-100 d-flex 
          justify-content-center align-items-center position-absolute
          ${mobile ? "overflow-hidden" : ""}`}
          style={{ 
            height: `${animationHeight}px`,
            }}>
          <div className="ratio ratio-16x9" 
            style={{ 
              mixBlendMode: "lighten",
              transform: `scale(${scaleVal})`,
              // opacity: "0.6",
            }}>
            <video className="w-100" src={Animation} autoPlay muted loop/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section2;

